module.exports = __webpack_public_path__ + "img/bt_luckydraw.36fdfe31.png";